import { api } from './client'
import type { SectionCreate, SectionOut, SectionPatch, SectionStatus, DocType, DocPhaseOut, DocPhasePatch } from '@/types'

export interface SectionCodeItem {
  code: string
  name: string
  description: string | null
  doc_type: DocType
  number: string | null
  parent_code: string | null
  sort_order: number
  is_active: boolean
}

export const sectionsApi = {
  list: (projectId: string, docType?: DocType) => {
    const params = docType ? { doc_type: docType } : {}
    return api.get<SectionOut[]>(`/projects/${projectId}/sections`, { params })
  },

  getCodes: (docType?: DocType) => {
    const params = docType ? { doc_type: docType } : {}
    return api.get<SectionCodeItem[]>('/sections/codes', { params })
  },

  create: (projectId: string, data: SectionCreate) =>
    api.post<SectionOut>(`/projects/${projectId}/sections`, data),

  patch: (sectionId: string, data: SectionPatch) =>
    api.patch<SectionOut>(`/sections/${sectionId}`, data),

  changeStatus: (sectionId: string, status: SectionStatus) =>
    api.patch<SectionOut>(`/sections/${sectionId}/status`, { status }),

  delete: (sectionId: string) =>
    api.delete(`/sections/${sectionId}`),
}

export const phasesApi = {
  list: (projectId: string) =>
    api.get<DocPhaseOut[]>(`/projects/${projectId}/phases`),

  patch: (projectId: string, docType: DocType, data: DocPhasePatch) =>
    api.patch<DocPhaseOut>(`/projects/${projectId}/phases/${docType}`, data),
}
